import { Component, Input, OnInit } from "@angular/core";
import { resourses, resousers } from "../contants";
import { WaterwiseService } from "../../../routes/services/waterwise.service";
import { FramesService } from "../../../routes/services/frames.service";
import { GlobalFunction } from "../../../routes/services/globalFuntion";
import { Options } from "@angular-slider/ngx-slider";
import { ConfigurationDeviceService } from "../../../routes/services/configuration-device.service";
import { ParametricsService } from "../../../routes/services/parametrics.service";
import {
  preferenceChecks,
  SinglePreferenceCheck,
  StorageService,
  typePreference
} from "../../../routes/services/storage.service";
import { sensors } from "../../../routes/Clients/device/constants";
import { MinMaxService } from "./services/min_max.service";

@Component({
  selector: "app-config-min-max-sensors-device",
  templateUrl: "./config.html",
  styleUrls: ["./config.scss"]
})
export class ConfigMinMaxComponent implements OnInit {
  @Input() type: "feeder" | "waterwise" | "farm" | "pond" = "feeder";
  @Input() id: number | "" = "";
  @Input() pond_id: number | "" = "";

  @Input() massiveUpdate = false;
  @Input() selectedItems = [];

  resourses_data: resousers[] = [];
  @Input() permissions = {
    change_parametricpreference: true
  };

  checks_parametry_preference: preferenceChecks = {
    TEM: true,
    PTEM: true,
    HUM: true,
    DO: true,
    EC: true,
    SAT: true,
    SG: true,
    SAL: true,
    TDS: true,
    PH: true,
    ORP: true,
    PRESSURE: true
  };
  @Input() viewNotifications: boolean = false;
  preferenceNotification: preferenceChecks = {
    TEM: true,
    PTEM: true,
    HUM: true,
    SAL: true,
    DO: true,
    SAT: true,
    PH: true,
    EC: true,
    TDS: true,
    SG: true,
    ORP: true,
    PRESSURE: true
  };

  constructor(
    public waterwiseService: WaterwiseService,
    public framesService: FramesService,
    public globalFunction: GlobalFunction,
    public configurationDeviceService: ConfigurationDeviceService,
    public minMaxService: MinMaxService,
    public storageService: StorageService
  ) {}
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.resourses_data = resourses.map((item) => {
      const sensor = sensors.find((sen) => sen.preference === item.prop);
      if (sensor) {
        return {
          ...item,
          min: sensor.min,
          max: sensor.max,
          preference: sensor.preference,
          measurementThreshold: sensor.measurementThreshold
        };
      }
      return item;
    });
    this.get_data();

    if (this.viewNotifications) {
      this.minMaxService.getNotificationPreference().subscribe((resp) => {
        console.log(resp);
        this.preferenceNotification = resp;
      });
    }
  }

  get_data() {
    /*
    Si es tipo granja, se solicitan todos los valores
    Si es por estanque, debe de mostrar la configuracion de la granja con los activos del estanque
    Si es por waterwise debe de mostrar la configuracion del estanque

  */

    const farm_id = Number(this.storageService.localValue.farm_id);
    if (farm_id) {
      if (this.type === "farm") {
        this.getPreferenceByFarm(farm_id);
      }

      if (this.id) {
        if (this.type === "pond") {
          this.getPreferencePond(farm_id, this.id).then((item: any) => {
            if (item.farm && item.preference) {
              this.checks_parametry_preference = item.farm;
              for (const key in this.storageService.checks_parametry_preference) {
                const index = this.resourses_data.findIndex((item) => item.preference === key);
                if (index >= 0) {
                  this.resourses_data[index].check = item.preference[key];
                }
              }
            }
          });
        }

        if (this.type === "waterwise" && this.pond_id) {
          console.log(this.pond_id);

          this.getPreferenceWaterwise(this.pond_id, this.id).then((item: any) => {
            if (item.pond && item.preference) {
              this.checks_parametry_preference = item.pond;
              for (const key in this.storageService.checks_parametry_preference) {
                const index = this.resourses_data.findIndex((item) => item.preference === key);
                if (index >= 0) {
                  this.resourses_data[index].check = item.preference[key];
                }
              }
            }
          });
        }
      }
    }

    if (this.id) {
      this.getConfigById(this.id);
    }
    if (this.massiveUpdate && this.selectedItems.length === 1) {
      this.getConfigById(this.selectedItems[0]["id"]);
      this.getPreferenceByFarm(farm_id);
    }
    if (this.massiveUpdate && this.selectedItems.length > 1) {
      this.getConfigById(farm_id, "farm");
    }
  }

  getPreferenceByFarm(farm_id: number) {
    this.minMaxService.getParametricPreference(`?farm_id=${farm_id}`).subscribe((resp) => {
      console.log(resp);
      if (resp.length > 0) {
        const resourses = resp[0];
        this.resourses_data.forEach((element: resousers, idx) => {
          if (
            element.preference &&
            Object.prototype.hasOwnProperty.call(resourses, element.preference)
          ) {
            if (resourses && element.preference) {
              this.resourses_data[idx].check = resourses[element.preference]
                ? resourses[element.preference]
                : false;
            }
          }
          this.checks_parametry_preference = resourses;
        });
        this.storageService.setParametryPreferences(resourses);
      }
    });
  }

  getPreferencePond = (farm_id: number, id: number) => {
    return new Promise(async (resolve, reject) => {
      try {
        const farm = await this.minMaxService
          .getParametricPreference(`?farm_id=${farm_id}`)
          .toPromise();
        if (farm.length > 0) {
          const config = farm[0];
          if (id) {
            const preference = await this.minMaxService
              .getParametricPreferencePondWaterwise(id, "PONDS")
              .toPromise();
            if (config && preference) {
              resolve({ farm: config, preference });
            }
          }
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  getPreferenceWaterwise = (pond_id: number, id: number) => {
    return new Promise(async (resolve, reject) => {
      try {
        const pond = await this.minMaxService
          .getParametricPreferencePondWaterwise(pond_id, "PONDS")
          .toPromise();
        if (pond) {
          if (id) {
            const preference = await this.minMaxService
              .getParametricPreferencePondWaterwise(id, "WATERWISE")
              .toPromise();
            if (pond && preference) {
              resolve({ pond, preference });
            }
          }
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  setValuePreference = (resp: preferenceChecks[], save: boolean = true) => {
    if (resp.length > 0) {
      const resourses = resp[0];
      this.resourses_data.forEach((element: resousers, idx) => {
        if (
          element.preference &&
          Object.prototype.hasOwnProperty.call(resourses, element.preference)
        ) {
          if (resourses && element.preference) {
            this.resourses_data[idx].check = resourses[element.preference]
              ? resourses[element.preference]
              : false;
          }
        }
        save && (this.checks_parametry_preference = resourses);
      });
    }
  };

  getConfigById(id: number, type = this.type) {
    this.configurationDeviceService.getConfiguration(id, type).subscribe((resp) => {
      this.resourses_data.forEach((item, idx) => {
        this.resourses_data[idx].min_value = resp[item.preference + `_min`]
          ? resp[item.preference + `_min`]
          : item.min;

        this.resourses_data[idx].max_value = resp[item.preference + `_max`]
          ? resp[item.preference + `_max`]
          : item.min;
      });
    });
  }
  submitAutomaticRequest() {
    let obj: any = {};
    this.resourses_data.forEach((item) => {
      obj[item.preference + `_min`] = item.min_value;
      obj[item.preference + `_max`] = item.max_value;
    });
    let query = this.massiveUpdate
      ? `?id_in=${this.selectedItems.map((item: any) => item.id)}`
      : "";
    this.configurationDeviceService
      .patchConfiguration(this.id, this.type, obj, query)
      .subscribe((resp) => {});
  }

  validateOptions = (val: resousers): Options => {
    let step = val.preference === "SG" ? { step: 0.00001 } : {};

    return {
      disabled: !this.permissions.change_parametricpreference,
      floor: val.min,
      ceil: val.max,
      translate: (value: number): string => {
        const format_value = value.toLocaleString("en-us", {
          minimumFractionDigits: 2
        });
        return format_value + val.measurementThreshold;
      },
      ...step
    };
  };
  changeCheck(item: resousers) {
    const farm_id = this.storageService.localValue.farm_id;
    console.log(item.preference);

    if (item.preference) {
      const preferenceKey = item.preference as keyof preferenceChecks;
      const obj = {
        [item.preference]: item.check
      } as SinglePreferenceCheck;

      if (this.type === "farm") {
        this.minMaxService
          .patchParametricPreferenceChangefarm(Number(farm_id), obj)
          .subscribe((resp) => {
            if (item.preference) {
              this.checks_parametry_preference[item.preference] = item.check;
              this.storageService.setSingleParametryPreference(preferenceKey, Boolean(item.check));
            }
          });
      }

      if (this.type === "waterwise" || this.type === "pond") {
        if (this.id) {
          const type = this.type === "waterwise" ? "WATERWISE" : "PONDS";
          this.minMaxService.patchParametricPreference(this.id, obj, type).subscribe((resp) => {
            this.storageService.setSingleParametryPreference(preferenceKey, Boolean(item.check));
          });
        }
      }
    }
  }
  removeConfiguration() {
    this.configurationDeviceService.deleteConfiguration(this.id, this.type).subscribe((resp) => {
      this.resourses_data.forEach((item, idx) => {
        this.resourses_data[idx].min_value = resp[item.preference + `_min`]
          ? resp[item.preference + `_min`]
          : item.min;

        this.resourses_data[idx].max_value = resp[item.preference + `_max`]
          ? resp[item.preference + `_max`]
          : item.min;
      });
    });

    if (this.type === "pond" || this.type === "waterwise") {
      const type = this.type === "pond" ? "ponds" : "waterwise";
      this.minMaxService.deleteParametricPreferences(Number(this.id), type).subscribe((resp) => {});
    }
  }

  sendNotification = (type: typePreference) => {
    return this.preferenceNotification[type] ? this.preferenceNotification[type] : false;
  };
  changePreferenceNotification = (resourse: resousers) => {
    if (resourse.preference) {
      const obj = {
        [resourse.preference]: !this.preferenceNotification[resourse.preference]
      } as SinglePreferenceCheck;

      this.minMaxService.patchNotificationPreference(obj).subscribe((resp) => {
        this.preferenceNotification = resp;
      });
    }
  };
}
